<template>
  <div class="contarner" >
    <div class="tip" >
      <p class="title" >解决方案</p>
      <p class="content" >提供多公司、多品牌、可持续发展的数字化方案</p>
    </div>
    <div class="cloudBox" >
      <div class="cloud" >
        <img src="./cloud.png" alt="" v-zoomIn >
        <div class="title" >营运云</div>
        <p>巡店、培训、考试、电子配方</p>
        <div class="hoverBox" >
          <div class="title" >营运云</div>
          <span class="content" >助力连锁门店营运管理改善。将企业营运管理经验标准化、数字化、流程化、规范化。总部制定规则标准、员工参与培训学习，通过线上方式考核验收，再结合巡店管理进行标准检验，有效降低了传统营运管理的人力、物力、时间成本。</span>
        </div>
      </div>
      <div class="cloud" >
        <img src="./chain.png" alt="" v-zoomIn >
        <div class="title" >供应链云</div>
        <p>支持集团化、多组织、多品牌</p>
        <div class="hoverBox" >
          <div class="title" >供应链云</div>
          <span class="content" >对外高效建立加盟店与总部、品牌与供应商线上便捷的订货、收货、对账等闭环流程。对内支持企业从供应商采购收货、生产完工、配送分货、成本核算等内稽内控管理。实现从外到内、从上游到下游，从原材料到产成品的全链条管理。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {

    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.contarner {
  background-color: #F0F0F0;
  padding: 40px 0 65px 0;
  overflow: hidden;

  @media screen and (max-width: 500px){
    padding: 20px 0 65px 0;
  }

  .tip {
    text-align: center;

    .title {
      font-size: 25px;
      font-weight: 500;
    }

    .content {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
    }

    @media screen and (max-width: 500px){
      .title {
        font-size: 18px;
      }

      .content {
        font-size: 12px;
      }
    }
  }

  .cloudBox {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .cloud {
      width: 48%;
      border: 2px solid #dfdfdf;
      border-radius: 4px;
      padding: 20px 0;
      position: relative;
      text-align: center;
      overflow: hidden;

      .title {
        font-size: 16px;
        margin-bottom: 20px;
      }

      p {
        color: #999;
      }

      img {
        width: 120px;
        height: 90px;
        margin: 20px 0;
      }

      .hoverBox {
        height: 100%;
        position: absolute;
        background-color: #4b9eea;
        color: white;
        padding: 0 20px;
        top: 100%;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: top 0.5s; 
      }

      &:hover .hoverBox {
        top: 0;
      }
      @media screen and (max-width: 500px) {
        .title {
          font-size: 15px;
        }
        p {
          font-size: 12px;
        }
        .hoverBox {
          font-size: 12px;
        }
      }
    }

    @media screen and (max-width: 500px) {
      flex-direction: column;

      .cloud {
        width: 100%;
        margin-bottom: 20px
      }
    }
  }
}
</style>
